import React from 'react';
import { colors } from 'helpers/ColorHelper.js';
import { toFriendlyDateTimeString } from 'helpers/Formatter';

const ReviewTerms = props => {
  const headerClass = {
    backgroundColor: colors.BODY_GRAY,
    margin: '20px -15px',
    textAlign: 'center',
    color: 'rgb(136, 136, 136)',
  };
  const infoClass = {
    whiteSpace: 'break-spaces',
    marginTop: '16px',
  };

  const { acceptedTerms, acceptedAtDate } = props;

  if (!acceptedTerms || !acceptedAtDate) return null;

  return (
    <div>
      <div className="row" style={headerClass}>
        <h5>Accepted Application Terms</h5>
      </div>
      <div className="row">
        <h4 style={{ margin: 0, marginBottom: '5px' }}>
          The following terms were accepted during the application process on{' '}
          {toFriendlyDateTimeString(acceptedAtDate)}
        </h4>
        <p style={infoClass}>{acceptedTerms}</p>
      </div>
    </div>
  );
};

export default ReviewTerms;
